import { render, staticRenderFns } from "./updateTemplate.vue?vue&type=template&id=3715c1ca&scoped=true&"
import script from "./updateTemplate.vue?vue&type=script&lang=js&"
export * from "./updateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./updateTemplate.vue?vue&type=style&index=0&id=3715c1ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3715c1ca",
  null
  
)

export default component.exports